import { Modal, useModals } from 'almanac-ui/Modal'
import { UpdateModal as UpdateModalType } from 'hooks/queries/updateModals/useUpdateModals'
import Styles from './UpdateModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const UpdateModal = ({ updateModal }: { updateModal: UpdateModalType }) => {
  const { isMobile } = useResponsiveDesign()
  const { closeModal } = useModals()

  const clearCache = async () => {
    if (window.caches) {
      const keys = await window.caches.keys()
      keys.forEach((cacheName) => {
        window.caches.delete(cacheName)
      })
    }
  }

  const handlePress = (url: string) => {
    clearCache()

    // Force navigation with a hard reload
    // eslint-disable-next-line no-restricted-properties
    window.location.replace(url)
  }

  return (
    <Modal.Root size="lg">
      <Modal.Header title="✨ What's New" preventClose />
      <Modal.Content>
        <div className={Styles.modalContent}>
          <img src={updateModal.hero_image_url} alt={updateModal.title} className={Styles.heroImage} />
          <div className={Styles.modalText}>
            <Heading level={3}>{updateModal.title}</Heading>
            <Text>{updateModal.copy}</Text>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        {!isMobile && (
          <Modal.FooterContent slot="left">
            <Button variant="tertiary" size="lg" onPress={closeModal}>
              Close
            </Button>
          </Modal.FooterContent>
        )}
        <Modal.FooterContent slot="right">
          <div className={Styles.buttons}>
            {updateModal.secondary_cta_copy && updateModal.secondary_cta_url ? (
              <Button
                variant="secondary"
                size="lg"
                onPress={() => handlePress(updateModal.secondary_cta_url as string)}
              >
                {updateModal.secondary_cta_copy}
              </Button>
            ) : null}
            <Button variant="primary" size="lg" onPress={() => handlePress(updateModal.primary_cta_url)}>
              {updateModal.primary_cta_copy}
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
